<template>


    <main class="main h-100 w-100">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
                    <div class="d-table-cell align-middle">

                        <div class="text-center mt-4">
                            <h1 class="h2">Bienvenue sur</h1>
                            <p class="lead">
                                Connectez-vous à votre compte pour continuer
                            </p>
                        </div>
                        <form @submit.prevent="handleSubmit">


                            <div class="card">
                                <div class="card-body">

                                    <div class="m-sm-4">
                                        <div class="text-center">
                                            <img src="@/assets/logo.jpg" alt="A" class="img-fluid rounded-circle"
                                                width="132" height="132" />
                                        </div>
                                        <div class="alert alert-danger alert-dismissible mt-4" role="alert"
                                            v-if="showMessage && !isSuccess">
                                            <div class="alert-message">
                                                <strong>Désolé!, </strong> {{ message }}
                                            </div>

                                            <button type="button" class="btn-close btn-close-white"
                                                data-bs-dismiss="alert" aria-label="Close">
                                            </button>
                                        </div>

                                        <div class="mb-3">
                                            <label>Nom d'utilisateur ou numéro de téléphone</label>
                                            <input class="form-control form-control-lg" type="text" name="text"
                                                placeholder="Entrer votre nom d'utilisateur" v-model="email" required />
                                        </div>
                                        <div class="mb-3">
                                            <label>Mot de passe</label>
                                            <input class="form-control form-control-lg" type="password" name="password"
                                                placeholder="Entrer votre mot de passe" v-model="password" required />

                                        </div>

                                        <div class="text-center mt-3">
                                            <button class="btn btn-lg btn-primary" type="submit" v-if="!loading">Se
                                                connecter</button>
                                            <div class="btn btn-lg btn-dark" v-else>En cours ...</div>
                                            <!-- <button type="submit" class="btn btn-lg btn-primary">Sign in</button> -->
                                            <div class="mt-3">
                                                <router-link :to="{ name: 'Register' }">Vous n'avez pas de compte
                                                    ?Inscrivez-vous</router-link>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </main>


</template>

<script>

import { mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
export default {
    name: 'LoginPage',
    data() {
        return {
            email: "",
            password: "",

        }
    },
    computed: {
        ...mapFields("auth", {
            loading: "isLoading",
            message: "message",
            showMessage: "showMessage",
            isSuccess: "isSuccess"

        })
    },
    methods: {
        ...mapActions({
            submitForm: 'auth/login'
        }),
        handleSubmit() {
            let credentials = { email: this.email, password: this.password }

            this.submitForm(credentials)

        },
        handleKeyPress(event) {
            if (event.keyCode === 13) {
                this.handleSubmit();
            }
        }
    },
    mounted() {
        // Écouter l'événement keydown sur les champs de formulaire
        document.addEventListener('keydown', this.handleKeyPress);
    },
    beforeUnmount() {
        // Supprimer l'écouteur d'événement lors de la destruction du composant
        document.removeEventListener('keydown', this.handleKeyPress);
    }
}
</script>

<style></style>